import React from 'react';
import styled from 'styled-components';
import CopyIconButton from '../CopyIconButton';

const ShareOptionsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
`;

const SocialButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`;

const SocialButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  @media (hover: hover) {
    &:hover {
      opacity: 0.8;
    }
  }
`;

const SocialButton = styled.img`
  width: 48px;
  height: 48px;
`;

const SocialButtonLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.text.secondary};
  font-weight: 500;
`;

const StyledCopyIconButton = styled(CopyIconButton)`
  width: 48px;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid ${({ theme }) => theme.border.primary};
  border-radius: 50%;
`;

const SocialShareOptions = ({ claimUrl, giftMessage = '' }) => {
  const defaultMessage =
    giftMessage ||
    `You've got crypto waiting for you! Claim your gift via Deks here: ${claimUrl}`;

  const handleShare = (platform) => {
    const encodedMessage = encodeURIComponent(defaultMessage);

    switch (platform) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodedMessage}`, '_blank');
        break;
      case 'telegram':
        window.open(
          `https://t.me/share/url?url=${claimUrl}&text=${encodedMessage}`,
          '_blank',
        );
        break;
      case 'sms':
        window.open(`sms:?body=${encodedMessage}`, '_blank');
        break;
      default:
        break;
    }
  };

  return (
    <ShareOptionsContainer>
      <SocialButtonsContainer>
        <SocialButtonContainer onClick={() => handleShare('whatsapp')}>
          <SocialButton src='/rewards/whatsapp.webp' alt='Share via WhatsApp' />
          <SocialButtonLabel>WhatsApp</SocialButtonLabel>
        </SocialButtonContainer>
        <SocialButtonContainer onClick={() => handleShare('telegram')}>
          <SocialButton src='/rewards/telegram.webp' alt='Share via Telegram' />
          <SocialButtonLabel>Telegram</SocialButtonLabel>
        </SocialButtonContainer>
        <SocialButtonContainer onClick={() => handleShare('sms')}>
          <SocialButton src='/rewards/sms.webp' alt='Share via SMS' />
          <SocialButtonLabel>Messages</SocialButtonLabel>
        </SocialButtonContainer>
        <SocialButtonContainer>
          <StyledCopyIconButton iconUrl='/copy.svg' textToCopy={claimUrl} />
          <SocialButtonLabel>Copy Link</SocialButtonLabel>
        </SocialButtonContainer>
      </SocialButtonsContainer>
    </ShareOptionsContainer>
  );
};

export default SocialShareOptions;
